import Tabs from './Tabs'
import { TabsProps, TabItemProps } from './types'

export default Tabs

export type { TabsProps, TabItemProps }
